import React from 'react';
import { Collapse, Grid, IconButton } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import InfoIcon from '@material-ui/icons/Info';

// NOTE // takes in a status and type and returns a status to display, or a color for that status
const getEmailStatus = (status, type) => {
  if (status === true) {
    return type === 'color' ? 'green' : 'Success'
  }
  else if (status === 'duplicate') {
    return type === 'color' ? 'blue' : 'Duplicate'
  }
  else {
    return type === 'color' ? 'red' : 'Failure'
  }
}

// NOTE // loop over each email result, create rloc groups, and format the email results for display
const formatEmailResults = (statusDict) => {
  let rlocArr = []
  for (const email in statusDict) {
    let emailResult = statusDict[email]
    let status = emailResult?.status
    let rloc = emailResult?.rloc
    if (rloc) {
      let rlocGroupLoc = rlocArr.findIndex(group => group.rloc === rloc)
      
      // NOTE // if the rloc email group does not exist already, create it
      if (rlocGroupLoc === -1) {
        rlocArr.push({rloc: rloc, status: null, emailResults: [], color: 'red'})
        // NOTE // setting the location of the new group
      }
      rlocGroupLoc = rlocArr.findIndex(group => group.rloc === rloc)

      // NOTE // formatting the emailResult for display
      let formattedEmailRes = {email: email, status: getEmailStatus(status), color: getEmailStatus(status, 'color')}
      rlocArr[rlocGroupLoc].emailResults.push(formattedEmailRes)
    }
  }

  return rlocArr
}

// NOTE // creating the rlocArr for display
const formatRlocArr = (statusDict) => {
  let rlocArr = formatEmailResults(statusDict)

  // NOTE // loop over rloc groups and format group results for display
  for (let i = 0; i < rlocArr.length; i++) {
    const rlocGroup = rlocArr[i];
    let hasFailures = rlocGroup.emailResults.findIndex(res => res.status !== 'Success')
    rlocGroup.status = hasFailures === -1 ? 'Success' : 'Failure'
    rlocGroup.color = hasFailures === -1 ? 'green' : 'red'
  }

  return rlocArr
}

// NOTE // shows the status of an email that an itinerary was sent to
const EmailItem = (props) => {
  const { emailRes } = props

  return (
    <Grid container justify="center" item xs={12}>
      <div style={{marginBottom: '8px'}}>{emailRes.email}: <span style={{color: emailRes.color}}>{emailRes.status}</span></div>
    </Grid>
  )
}

// NOTE // a display item for an rloc group
// NOTE // shows the rloc, status for rloc (any failed email would show failure), and a list of emails with their status
const RlocItem = (props) => {
  const { group } = props
  const emails = group.emailResults
  const [showEmails, setShowEmails] = React.useState(group.status === 'Failure');

  return (
    <Grid container justify="center" item xs={12} style={{borderBottom: '2px solid #b9b9b9'}}>
      <Grid container item xs={12}>
        <Grid container item xs={2}>
          <IconButton aria-label="expand row" size="small" onClick={() => setShowEmails(!showEmails)}>
            {showEmails ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Grid>
        <Grid container justify="center" item xs={8}>
          <p>{group.rloc}: <span style={{color: group.color}}>{group.status}</span></p>
        </Grid>
      </Grid>
      <Grid container justify="center" item xs={12}>
        <Collapse in={showEmails} timeout="auto" unmountOnExit>
          {/* <Grid > */}
            {emails.map((key, index) => {
              let emailRes = group.emailResults[index]
              return <EmailItem key={emailRes.email} emailRes={emailRes} />
            })}
          {/* </Grid> */}
        </Collapse>
      </Grid>
    </Grid>
  )
}

const InformationHover = () => {
  return (
    <Grid container justify="center" item xs={12}>
      <Grid container justify="center" item xs={12}>
        <h3 style={{margin: '8px'}}>Status Display Info</h3>
      </Grid>
      <Grid container justify="flex-start" item xs={12}>
        <p>
          This display is used to check the status of each email that has attempted to send to an itinerary recipient. The status for an rloc will be either Success or Failure,
          with a Failure meaning it contains at least one email that was a Failure or Duplicate. The status for an email will either be Success, Failure, or Duplicate, where
          a duplicate means that an itinerary has been sent to the same email within the last 5 minutes. Each rloc could have multiple emails which is why each group can expand to
          show the status for each email sent for that rloc.
        </p>
      </Grid>
    </Grid>
  )
}

const RlocAndInfoDisplay = (props) => {
  const {rlocArr, showHelp} = props

  if (showHelp) {
    return (
      <Grid container justify="center" item xs={11}>
        <InformationHover />
      </Grid>
    )
  }
  else {
    return (
    <Grid container justify="center" item xs={12}>
      {
        rlocArr.map((key, index) => {
          let group = rlocArr[index]
          return <RlocItem key={group.rloc} group={group} id={`rloc-item-${index}`} />
        })
      }
    </Grid>
    )
  }
}

// NOTE // on sending an itinerary, displays a status for each recipient
export const ItinStatusDisplay = (props) => {
  const [showHelpInfo, setShowHelpInfo] = React.useState(false)
  // NOTE // an object with each message being an object with the contact-info (email or phone-number) as the key
  let status = props.status
  // let status = 'loading'

  if (typeof status === 'string') {
    return (
      <Grid container justify="center" item xs={12} style={{margin: '25px', fontWeight: 'bold', fontSize: 'larger'}}>
        {status === 'loading' ? 'loading...' : 'an unexpected error occured'}
      </Grid>
    )
  }
  else if (typeof status === 'object') {
    let rlocArr = formatRlocArr(status)
  
    return (
      <Grid container justify="center" item xs={12}>
        <Grid container justify="center" item xs={12} style={{backgroundColor: '#3f51b5', borderTopRightRadius: '3px', borderTopLeftRadius: '3px'}}>
          <Grid container justify="center" item xs={11}>
            <h3 style={{margin: '8px', paddingLeft: '8%', fontSize: 'x-large'}}>
              Send Itinerary
            </h3>
          </Grid>
          <Grid container justify="center" item xs={1}>
            <IconButton onClick={() => {setShowHelpInfo(!showHelpInfo)}} style={{width: '100%', color: ''}}>
              <InfoIcon />
            </IconButton>
          </Grid>
        </Grid>
        <RlocAndInfoDisplay rlocArr={rlocArr} showHelp={showHelpInfo} />
      </Grid>
    )
  }
  else {
    return <div></div>
  }
}